import { useTrainingTranslation } from '../hooks/useTrainingTranslation';
import CourseCard from './CourseCard';

const CourseGrid = () => {
  const { getTranslation } = useTrainingTranslation();
  const courseKeys = Object.keys(getTranslation().courses);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      {courseKeys.map((key) => (
        <CourseCard key={key} courseKey={key} />
      ))}
    </div>
  );
};

export default CourseGrid;
